import { Condition } from "@/pages/Cases/types/Cases";
import { httpDelete, httpGet, httpPatch, httpPost } from "../connection.js";

//Case Reports API
async function getCaseReports(values: {
  case_id: string;
  case_report_id?: number;
}) {
  let url = `/cases/${values.case_id}/case-reports`;
  if (values.case_report_id) {
    url += `/${values.case_report_id}`;
  }
  return await httpGet(url, values);
}

async function query(query: {
  query: {
    case_id: string;
    page: number;
    pageSize: number;
    search?: string;
    order?: { field: "description"; sort: "asc" };
    conditions: Condition[];
  };
}) {
  return await httpPost(
    `/cases/${query.query.case_id}/case-reports/query`,
    query
  );
}

async function createCaseReport(params: {
  case_id: number | string;
  name: string;
  description?: string;
}) {
  return await httpPost(`/cases/${params.case_id}/case-reports`, params);
}

async function updateCaseReport(params: {
  case_id: string | number;
  case_report_id: number;
  report_parameters?: string;
  name?: string;
  description?: string;
}) {
  return await httpPatch(
    `/cases/${params.case_id}/case-reports/${params.case_report_id}`,
    params
  );
}

async function deleteCaseReport(params: {
  case_id: number | string;
  case_report_id: number;
}) {
  return await httpDelete(
    `/cases/${params.case_id}/case-reports/${params.case_report_id}`
  );
}

//Case Report Exports API
// /:case_id/case-reports/:case_report_id/exports
async function getCaseReportExports(params: {
  case_id: string;
  case_report_id: string;
}) {
  return await httpGet(
    `/cases/${params.case_id}/case-reports/${params.case_report_id}/exports`,
    params
  );
}

async function createCaseReportExport(params: {
  case_id: string;
  case_report_id: number;
  utcOffset: number;
  timezone: string;
  report_parameters: string;
}) {
  return await httpPost(
    `/cases/${params.case_id}/case-reports/${params.case_report_id}/exports`,
    params
  );
}

async function deleteCaseReportExport(params: {
  case_id: number;
  case_report_id: number;
  report_id: number;
}) {
  return await httpDelete(
    `/cases/${params.case_id}/case-reports/${params.case_report_id}/exports/${params.report_id}`
  );
}

async function exportCaseReportList(query: {
  query: {
    case_id: number;
    case_report_id: number;
  };
}) {
  const { case_id, case_report_id } = query.query;
  return await httpPost(
    `/cases/${case_id}/case-reports/${case_report_id}/export`,
    query
  );
}

const CaseReportsAPI = {
  query,
  getCaseReports,
  createCaseReport,
  updateCaseReport,
  deleteCaseReport,
  getCaseReportExports,
  createCaseReportExport,
  deleteCaseReportExport,
  exportCaseReportList,
};

export default CaseReportsAPI;
